export default function ezyManageSubscriptionDirective($state, $http, ReadQueries) {
    return {
        restrict: 'E',
        scope: {
            entity: '&',
            entityName: '@',
            entry: '&',
            size: '@',
            label: '@',
        },
        link: function (scope, element, attrs) {
            scope.label = scope.label || 'Manage Subscripion';
            var entityName = scope.entity() ? scope.entity().name() : attrs.entityName;
            var stateParams = entityName == $state.params.entity ? { ...$state.params } : {};
            stateParams.entity = entityName;
            stateParams.id = scope.entry().identifierValue;
            scope.stateParams = stateParams;
            scope.manage = () => {
                ReadQueries.getOne(scope.entity(), 'ShowView', stateParams.id, 'ShowView', null).then((entry) => {
                    $http({
                        method: 'POST',
                        url: 'https://app.ezyinsights.com/api/subscription/' + entry.id + '/manage/',
                        withCredentials: true
                    }).success(() => {
                        window.open('https://app.ezyinsights.com', '_blank');
                    });
                }).catch((err) => console.error(err))
            };
        },
        template:
` <a class="btn btn-default" ng-class="size ? \'btn-\' + size : \'\'" ng-click="manage(stateParams)">
<span class="glyphicon glyphicon-cog" aria-hidden="true"></span>&nbsp;<span class="hidden-xs" translate="{{ ::label }}"></span>
</a>`
    };
}

ezyManageSubscriptionDirective.$inject = ['$state', '$http', 'ReadQueries'];



// WEBPACK FOOTER //
// ./client/app/directives/ezyManageSubscription.js